import { render } from "./MailBox.vue?vue&type=template&id=a721958c"
import script from "./MailBox.vue?vue&type=script&lang=js"
export * from "./MailBox.vue?vue&type=script&lang=js"

import "./MailBox.vue?vue&type=style&index=0&id=a721958c&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__